import styled from 'styled-components';
import ds from 'designsystem';

const UnorderedList = styled.ul`
  line-height: ${ds.get('type.lineHeight.s')};
  list-style: none;
  padding-left: 30px;

  li {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(8px);
      width: 7px;
      height: 7px;
      background: ${ds.brand('darkPurple')};
      margin-left: -20px;
      border-radius: 50%;
    }
  }
`;

export default UnorderedList;



// WEBPACK FOOTER //
// ./src/elements/UnorderedList.js